import {
  ExternalLink,
  Camera
} from "lucide-react";

import {
  useQuery
} from "@tanstack/react-query";

import {
  Link
} from "react-router";

import {
  getHomepageInstagramPosts,
  getPublicInstagramImageUrl
} from "../../services/catalog";

export function CmsInstagramSection() {
  const query =
    useQuery({
      queryKey: [
        "homepage",
        "instagram"
      ],

      queryFn:
        getHomepageInstagramPosts,

      staleTime: 0,

      refetchOnMount:
        "always",

      refetchOnWindowFocus:
        true
    });

  const posts =
    query.data ??
    [];

  if (
    !query.isLoading &&
    posts.length === 0
  ) {
    return null;
  }

  return (
    <section className="rini-section bg-[#fffdf8]">
      <div className="rini-container text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.22em] text-[#70845b]">
          Follow our handmade journey
        </p>

        <h2 className="rini-heading mt-4 text-4xl font-semibold sm:text-5xl">
          @rini_bodycare
        </h2>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-[#746d65]">
          Follow RiNi for product stories,
          handmade moments and a closer look
          at our everyday bodycare journey.
        </p>

        {query.isLoading ? (
          <div className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-4">
            {Array.from({
              length: 4
            }).map(
              (_item, index) => (
                <div
                  key={index}
                  className="aspect-square animate-pulse rounded-3xl bg-[#eee8df]"
                />
              )
            )}
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-4">
            {posts.map(
              (post) => {
                const image =
                  post.imageKey
                    ? getPublicInstagramImageUrl(
                        post.id,
                        post.imageKey
                      )
                    : null;

                const content = (
                  <>
                    {image ? (
                      <img
                        src={
                          image
                        }
                        alt={
                          post.caption ??
                          "RiNi Instagram"
                        }
                        loading="lazy"
                        className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.04]"
                      />
                    ) : (
                      <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-[#ded2c0] to-[#9f8067]">
                        <span className="font-serif text-2xl text-white">
                          RiNi
                        </span>
                      </div>
                    )}

                    <div className="absolute inset-0 flex items-end bg-gradient-to-t from-black/60 via-black/5 to-transparent opacity-0 transition duration-300 group-hover:opacity-100">
                      <div className="w-full p-4 text-left text-white">
                        <Camera
                          size={20}
                        />

                        {post.caption && (
                          <p className="mt-2 line-clamp-2 text-sm leading-5">
                            {
                              post.caption
                            }
                          </p>
                        )}
                      </div>
                    </div>
                  </>
                );

                if (
                  post.instagramUrl
                ) {
                  return (
                    <a
                      key={
                        post.id
                      }
                      href={
                        post.instagramUrl
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="group relative aspect-square overflow-hidden rounded-3xl bg-[#eee8df]"
                    >
                      {content}
                    </a>
                  );
                }

                if (
                  post.productUrl
                ) {
                  return (
                    <Link
                      key={
                        post.id
                      }
                      to={
                        post.productUrl
                      }
                      className="group relative aspect-square overflow-hidden rounded-3xl bg-[#eee8df]"
                    >
                      {content}
                    </Link>
                  );
                }

                return (
                  <div
                    key={
                      post.id
                    }
                    className="group relative aspect-square overflow-hidden rounded-3xl bg-[#eee8df]"
                  >
                    {content}
                  </div>
                );
              }
            )}
          </div>
        )}

        <a
          href="https://www.instagram.com/rini_bodycare/"
          target="_blank"
          rel="noreferrer"
          className="rini-button-secondary mt-9"
        >
          <Camera
            size={18}
          />

          Visit Instagram

          <ExternalLink
            size={16}
          />
        </a>
      </div>
    </section>
  );
}
